module.exports = __webpack_public_path__ + "img/credit.29e1c8c3.png";